<template>
  <div>
    <!-- <div>
      <v-sheet elevation="0" color="#57bc90" style="min-height: 70vh;">
        <p class="text-center body-1 font-weight-bold pt-3">
          Check back after week 1 of NBA
        </p>
      </v-sheet>
    </div> -->
    <div>
      <v-sheet elevation="0" color="#57bc90" style="min-height: 105vh">
        <!-- //* game stats... -->
        <p class="text-h5 white--text font-weight-bold">Game Logs</p>
        <div class="mt-n3">
          <v-data-table
            :headers="header"
            :items="stats"
            class="elevation-1"
            hide-default-footer
            sort-by="Day"
            sort-desc
            mobile-breakpoint="0"
          >
            <!-- header -->
            <template
              v-for="h in header"
              v-slot:[`header.${h.value}`]="{ header }"
            >
              <v-tooltip bottom :key="h.text">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ h.text }}</span>
                </template>
                <span>{{ h.hint }}</span>
              </v-tooltip>
            </template>
            <!-- header -->

            <template v-slot:item.Day="{ item }">
              <p class="blue--text">{{ item.Day | dayFormatV2 }}</p>
            </template>

            <template v-slot:item.FantasyPointsDraftKings="{ item }">
              <p v-if="operator == 'FanDuel'" class="body-2">
                {{ item.FantasyPointsFanDuel }}
              </p>

              <p v-if="operator == 'DraftKings'" class="body-2">
                {{ item.FantasyPointsDraftKings }}
              </p>
            </template>
          </v-data-table>
        </div>

        <!-- //* season stats... -->
        <!--        <p class="text-h5 white&#45;&#45;text font-weight-bold mt-3">-->
        <!--          Season Logs-->
        <!--        </p>-->
        <!--        <div>-->
        <!--          <v-data-table-->
        <!--            :headers="seasonHeader"-->
        <!--            :items="stats"-->
        <!--            class="elevation-1"-->
        <!--            hide-default-footer-->
        <!--            sort-by="Day"-->
        <!--            sort-desc-->
        <!--            mobile-breakpoint="0"-->
        <!--          >-->
        <!--            &lt;!&ndash; header &ndash;&gt;-->
        <!--            <template-->
        <!--              v-for="h in seasonHeader"-->
        <!--              v-slot:[`header.${h.value}`]="{ seasonHeader }"-->
        <!--            >-->
        <!--              <v-tooltip bottom :key="h.text">-->
        <!--                <template v-slot:activator="{ on }">-->
        <!--                  <span v-on="on">{{ h.text }}</span>-->
        <!--                </template>-->
        <!--                <span>{{ h.hint }}</span>-->
        <!--              </v-tooltip>-->
        <!--            </template>-->
        <!--            &lt;!&ndash; header &ndash;&gt;-->

        <!--            <template v-slot:item.Day="{ item }">-->
        <!--              <p class="blue&#45;&#45;text">{{ item.Day | dayFormatV2 }}</p>-->
        <!--            </template>-->

        <!--            <template v-slot:item.FantasyPointsDraftKings="{ item }">-->
        <!--              <p v-if="operator == 'FanDuel'" class="body-2">-->
        <!--                {{ item.FantasyPointsFanDuel }}-->
        <!--              </p>-->

        <!--              <p v-if="operator == 'DraftKings'" class="body-2">-->
        <!--                {{ item.FantasyPointsDraftKings }}-->
        <!--              </p>-->
        <!--            </template>-->
        <!--          </v-data-table>-->
        <!--        </div>-->
      </v-sheet>
    </div>
  </div>
</template>

<script>
export default {
  name: "NbafullStats",
  props: {
    stats: {
      type: [Array, Object],
      default: () => [],
    },
  },

  data: () => ({
    header: [
      { text: "Season", value: "Season", hint: "date" },
      { text: "Team", value: "Opponent", hint: "Opponent" },
      { text: "ATS", value: "Assists", hint: "assist" },
      { text: "GP", value: "Games", hint: "games played" },
      { text: "GS", value: "Started", hint: "games started" },
      { text: "MPG", value: "Minutes", hint: "minutes per game" },
      {
        text: "FG%",
        value: "FieldGoalsPercentage",
        hint: "field goal percentage",
      },
      {
        text: "3P% 	",
        value: "ThreePointersPercentage",
        hint: "3-point field goal percentage",
      },
      {
        text: "FT% ",
        value: "FreeThrowsPercentage",
        hint: "free throw percentage",
      },
      { text: "REB", value: "Rebounds", hint: "Rebounds" },
      { text: "SPG", value: "Steals", hint: "steals per game" },
      { text: "BPG", value: "BlockedShots", hint: "Blocks per game" },
      { text: "PPG", value: "Points", hint: "Points" },
    ],

    seasonHeader: [
      { text: "Season", value: "Season", hint: "Season" },
      { text: "Opponent", value: "Opponent", hint: "Opponent" },
      { text: "ATS", value: "Assists", hint: "assist" },
      { text: "GP", value: "Games", hint: "games played" },
      { text: "GS", value: "Started", hint: "games started" },
      { text: "MPG", value: "Minutes", hint: "minutes per game" },
      {
        text: "FG%",
        value: "FieldGoalsPercentage",
        hint: "field goal percentage",
      },
      {
        text: "3P% 	",
        value: "ThreePointersPercentage",
        hint: "3-point field goal percentage",
      },
      {
        text: "FT% ",
        value: "FreeThrowsPercentage",
        hint: "free throw percentage",
      },
      { text: "REB", value: "Rebounds", hint: "Rebounds" },
      { text: "SPG", value: "Steals", hint: "steals per game" },
      { text: "BPG", value: "BlockedShots", hint: "Blocks per game" },
      { text: "PPG", value: "Points", hint: "Points" },
    ],
  }),
};
</script>

<style scoped>
.basil {
  background-color: #fffbe6 !important;
}

.basil--text {
  color: #356859 !important;
}
</style>
